import { Const, BuildTarget } from '@/const';
import { DebugHelper } from './debugHelper';

export class UserAgentHelper
{
    public static getBrowser() : string
    {
        var userAgent = window.navigator.userAgent.toLowerCase();
        var browser = "unknown";
        if(userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
            browser = "ie";
        } else if(userAgent.indexOf('edge') != -1) {
            browser = "edge";
        } else if(userAgent.indexOf('chrome') != -1) {
            browser = "chrome";
        } else if(userAgent.indexOf('safari') != -1) {
            browser = "safari";
        } else if(userAgent.indexOf('firefox') != -1) {
            browser = "firefox";
        } else if(userAgent.indexOf('opera') != -1) {
            browser = "opera";
        } else {
            browser = "unknown";
        }

        return browser;
    }

    public static getBrowserVersion() : string
    {
        try
        {
            let platform = require('platform');
            return platform.version;
        }
        catch(ex)
        {
            DebugHelper.trace("cannot get browser version.");
            return "0.0.0";
        }
    }

    public static getOS() : string
    {
        var userAgent = window.navigator.userAgent.toLowerCase();
        var os = "";

        if(userAgent.match(/Mac|PPC|mac os x/))
        {
            os = "MacOS";
        }
        else
        {
            os = "other";
        }

        return os;
    }

    public static isElectron() : boolean
    {
        var userAgent = window.navigator.userAgent.toLowerCase();
        return userAgent.indexOf('electron') != -1;
    }

    public static getDevice() : string
    {
        var ua = navigator.userAgent;
        if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
            // スマホ
            return 'sp';
        }else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
            // タブレット
            return 'tab';
        }else{
            // その他
            return 'other';
        }
    }

    public static isMobile()
    {
        // モバイル版かどうか
        return Const.BUILD_OPTION === BuildTarget.Mobile;
    }
}
